export const END_POINT = {
  BLOGS: "/user/blogs",
};
